import React from 'react';
import { Modal, Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../button';
import { useSubscriptionModalStore } from '../../utils/subscriptionModalStore';
import { ROUTERS_PATH } from '../../routers/routers';
import './subscription-expired-modal.scss';

const SubscriptionExpiredModal: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isOpen, closeModal } = useSubscriptionModalStore();

  const handleRenewSubscription = () => {
    closeModal();
    navigate(ROUTERS_PATH.CHOOSEPACKAGES);
  };

  return (
    <Modal 
      open={isOpen} 
      onClose={closeModal}
      slotProps={{
        backdrop: {
          className: 'subscription-expired-backdrop'
        }
      }}
    >
      <Box className="subscription-expired-modal-box">
        <div className="subscription-expired-modal-header">
        <h3 className="subscription-expired-title">{t('subscriptionExpiredTitle')}</h3>
        <button className="modal-close-btn" onClick={closeModal} aria-label="Close">×</button>
        </div>
        <p className="subscription-expired-message">{t('subscriptionExpiredMessage')}</p>
        <div className="subscription-expired-actions">
          <Button 
            text={t('renewSubscriptionNow')} 
            color="blue" 
            onClick={handleRenewSubscription} 
          />
          <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`} className="button support-link">
            {t('contactSupport')}<span className='support-link-email'>{import.meta.env.VITE_SUPPORT_EMAIL}</span>                                  
          </a>          
        </div>
      </Box>
    </Modal>
  );
};

export default SubscriptionExpiredModal;

